// eslint-disable-next-line angular/factory-name
angular.
module("focus", []).
directive("focusOn", function focusOnDirective() {
	"use strict";

	return function link(scope, elem, attr) {
		scope.$on("focusOn", function onFocusOn(e, name) {
			if (name === attr.focusOn) {
				elem[0].focus();
			}
		});
	};
}).
factory("focus", function focusFactory($rootScope, $timeout) {
	"use strict";

	return function focusFactoryReturn(name) {
		$timeout(function onTimeout() {
			$rootScope.$broadcast("focusOn", name);
		});
	};
});
